import React, { FC } from 'react';
import MuiIconButton, { IconButtonProps as MuiIconButtonProps } from '@mui/material/IconButton';
import MuiTooltip from '@mui/material/Tooltip';

export interface IconButtonProps extends MuiIconButtonProps {
    noBackground?: boolean;
    tooltiop?: string;
}

const IconButton: FC<IconButtonProps> = (props) => {
    const { tooltiop, noBackground } = props;

    const buttonProps = { ...props };
    delete buttonProps.tooltiop;
    delete buttonProps.noBackground;

    const componentRender = (
        <MuiIconButton
            {...buttonProps}
            sx={{
                ...props.sx,
                ...(noBackground
                    ? {
                          '&:hover': {
                              backgroundColor: 'inherit',
                          },
                      }
                    : {}),
            }}
        />
    );
    if (tooltiop) {
        return <MuiTooltip title={tooltiop}>{componentRender}</MuiTooltip>;
    }

    return componentRender;
};

export default IconButton;
